import { render, staticRenderFns } from "./IconRemove.vue?vue&type=template&id=7ecff3b4&scoped=true"
import script from "./IconRemove.vue?vue&type=script&lang=js"
export * from "./IconRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecff3b4",
  null
  
)

export default component.exports